import React, { useEffect, useState } from 'react';
import Button from '@/components/Button/Button';
import { T } from '@tolgee/react';
import Image from 'next/image';
import { DEFAULT_STRAPI_SORT, getPartners } from '@/services/strapiService';
import { useSelectedLanguage } from '@/redux/selectors/languageSelector';

interface Partner {
  id: number;
  attributes: {
    logo: {
      data: {
        attributes: {
          url: string;
        };
      };
    };
    name: string;
  };
}

const PartnersSection: React.FC = () => {
  const [partners, setPartners] = useState<Partner[]>([]);
  const locale = useSelectedLanguage();

  useEffect(() => {
    const fetchPartners = async () => {
      try {
        const response = await getPartners(8, 0, DEFAULT_STRAPI_SORT, locale);
        setPartners(response.data);
      } catch (error) {
        console.error('Error fetching partners:', error);
      }
    };

    void fetchPartners();
  }, []);

  return (
    <section className="pt-2xl pt-8 px-8 md:px-2xl mx-8 bg-gray rounded-none md:rounded-3xl">
      <h3 className="text-sm font-semibold text-primary uppercase mb-5 text-center md:text-left">
        <T>home.additional_support_options.apps_courses.label</T>
      </h3>
      <div className="flex flex-col lg:flex-row justify-between items-center mb-12">
        <div className="mb-8 lg:mb-0">
          <h2 className="text-4xl md:text-6xl mb-4 w-full md:w-3/4 mx-auto md:mx-0 text-center md:text-left">
            <T>home.apps_courses_section.title.label</T>
          </h2>
        </div>
        <div>
          <p className="text-base w-full md:w-3/4 text-center md:text-left py-2">
            <T>home.apps_courses_section.text.label</T>
          </p>
          <div className="w-48 mt-lg mx-auto md:mx-0">
            <Button variant="primary" href="/partners">
              <T>home.apps_courses_section.button.discover.label</T>
            </Button>
          </div>
        </div>
      </div>
      <div className="grid grid-cols-2 sm:grid-cols-2 md:grid-cols-3 lg:grid-cols-4 gap-4 mt-8 overflow-hidden">
        {partners.map((partner, index) => (
          <div
            key={partner.id}
            className={`flex items-center justify-center bg-white px-4 py-16 rounded-2xl filter grayscale hover:grayscale-0 transition-all duration-300 ${index % 2 ? 'transform translate-y-16' : 'translate-y-8'}`}
          >
            <Image
              src={partner.attributes.logo.data.attributes.url}
              alt={partner.attributes.name}
              width={100}
              height={100}
              className="object-contain"
            />
          </div>
        ))}
      </div>
    </section>
  );
};

export default PartnersSection;
